// extracted by mini-css-extract-plugin
module.exports = {"input":"InputWithLeftLabel_input__1FQbS"};